/* eslint-disable @typescript-eslint/no-empty-interface */
import type { DSPropTypesSchema } from '@elliemae/ds-props-helpers';
import { PropTypes } from '@elliemae/ds-props-helpers';
export declare namespace DSHookFloatingContextT {
  export interface DefaultProps {
    withoutPortal: boolean;
    withoutAnimation: boolean;
    portalDOMContainer?: HTMLElement;
    animationDuration: number;
    placement: PopperPlacementsT;
    customOffset: [number, number];
  }

  export interface OptionalProps {
    placementOrderPreference?: PopperPlacementsT[];
    onOpen?: () => void;
    onClose?: () => void;
    externallyControlledIsOpen?: boolean;
  }
  export interface Props extends Partial<DefaultProps>, OptionalProps {}

  export interface InternalProps extends DefaultProps, OptionalProps {}

  export type PopperPlacementsT =
    | 'top-start'
    | 'top'
    | 'top-end'
    | 'right-start'
    | 'right'
    | 'right-end'
    | 'bottom-end'
    | 'bottom'
    | 'bottom-start'
    | 'left-end'
    | 'left'
    | 'left-start';
}

export const defaultProps: DSHookFloatingContextT.DefaultProps = {
  withoutAnimation: false,
  animationDuration: 300,
  withoutPortal: false,
  placement: 'top',
  customOffset: [0, 12],
};

export const DSFloatingContextPropTypes: DSPropTypesSchema<DSHookFloatingContextT.Props> = {
  withoutPortal: PropTypes.bool
    .description('If true, the tooltip will not be rendered inside a portal.')
    .defaultValue(false),
  withoutAnimation: PropTypes.bool.description('If true, the tooltip will not have an animation.').defaultValue(false),
  portalDOMContainer: PropTypes.instanceOf(HTMLElement)
    .description('The DOM element where the tooltip will be rendered.')
    .defaultValue('the first "main" landmark available in the document or the body if no "main" is found'),
  animationDuration: PropTypes.number.description('The duration of the animation in milliseconds.').defaultValue(300),
  placement: PropTypes.oneOf([
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start',
  ])
    .description('The placement of the tooltip.')
    .defaultValue('top'),
  customOffset: PropTypes.arrayOf(PropTypes.number)
    .description('The custom offset of the tooltip.')
    .defaultValue([12, 12]),
  placementOrderPreference: PropTypes.oneOfType([
    PropTypes.tuple([PropTypes.oneOf(['top-start'])]),
    PropTypes.tuple([PropTypes.oneOf(['top'])]),
    PropTypes.tuple([PropTypes.oneOf(['top-end'])]),
    PropTypes.tuple([PropTypes.oneOf(['right-start'])]),
    PropTypes.tuple([PropTypes.oneOf(['right'])]),
    PropTypes.tuple([PropTypes.oneOf(['right-end'])]),
    PropTypes.tuple([PropTypes.oneOf(['bottom-end'])]),
    PropTypes.tuple([PropTypes.oneOf(['bottom'])]),
    PropTypes.tuple([PropTypes.oneOf(['bottom-start'])]),
    PropTypes.tuple([PropTypes.oneOf(['left-end'])]),
    PropTypes.tuple([PropTypes.oneOf(['left'])]),
    PropTypes.tuple([PropTypes.oneOf(['left-start'])]),
  ]).description('The order of the placement preference.'),
  onOpen: PropTypes.func.description('Callback when the tooltip is opened.'),
  onClose: PropTypes.func.description('Callback when the tooltip is closed.'),
  externallyControlledIsOpen: PropTypes.bool.description(
    'If true, the context open/close state will be controlled externally.',
  ),
};
